import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./PagosTable.css";

export default function PagosTable({
  pagos,
  paciente,
  dateFilter,
  setDateFilter,
}) {
  const PAGE_SIZE = 5;
  const [page, setPage] = useState(1);

  const filtered = pagos.filter((p) => {
    if (!dateFilter) return true;
    const fecha = new Date(p.date).toISOString().slice(0, 10);
    return fecha === dateFilter;
  });

  const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
  const start = (page - 1) * PAGE_SIZE;
  const items = filtered.slice(start, start + PAGE_SIZE);

  return (
    <>
      <div className="pv-filter">
        <input
          type="date"
          value={dateFilter}
          onChange={(e) => setDateFilter(e.target.value)}
        />
        {dateFilter && (
          <button className="clear-btn" onClick={() => setDateFilter("")}>
            Limpiar
          </button>
        )}
      </div>

      {filtered.length === 0 ? (
        <p>No hay pagos registrados.</p>
      ) : (
        <>
          <div className="pv-table-wrapper">
            {/* 👇 aquí el cambio de clase */}
            <table className="pv-table pv-table-pagos">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Paciente</th>
                  <th>Servicio</th>
                  <th>Importe (€)</th>
                  <th>Método</th>
                  <th>Estado</th>
                  <th>Factura</th>
                </tr>
              </thead>
              <tbody>
                {items.map((p) => (
                  <tr key={p.id}>
                    <td>{new Date(p.date).toLocaleDateString("es-ES")}</td>
                    <td>{paciente.nombre}</td>
                    <td>{p.service_name || "-"}</td>
                    {/* 👇 quitamos el style inline, lo hace el CSS */}
                    <td>
                      {p.amount && !isNaN(p.amount)
                        ? `${parseFloat(p.amount).toFixed(2)} €`
                        : "—"}
                    </td>
                    <td>
                      {p.payment_method === "efectivo"
                        ? "💵 Efectivo"
                        : p.payment_method === "tarjeta"
                        ? "💳 Tarjeta"
                        : "-"}
                    </td>
                    <td>
                      <span
                        className={`status-pill ${
                          p.status === "pagado" ? "paid" : "pending"
                        }`}
                      >
                        {p.status === "pagado" ? "Pagado" : "Pendiente"}
                      </span>
                    </td>
                    <td>
                      <Link
                        to={`/admin/factura/${p.id}`}
                        className="invoice-btn"
                        title="Ver factura"
                      >
                        🧾
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {totalPages > 1 && (
            <div className="pagination">
              <button onClick={() => setPage(page - 1)} disabled={page === 1}>
                ← Anterior
              </button>
              <span>
                Página {page} de {totalPages}
              </span>
              <button
                onClick={() => setPage(page + 1)}
                disabled={page === totalPages}
              >
                Siguiente →
              </button>
            </div>
          )}
        </>
      )}
    </>
  );
}
